export type DeviceState =
  | "unknown"
  | "on"
  | "off"
  | "idle"
  | "charging"
  | "discharging"
  | "heat"
  | "eco"
  | "cool"
  | "auto"
  | "connected"
  | "disconnected";

export type MetricFormat = "percentage" | "kW" | "temperature";

export const deviceStateMetricFormats: Record<DeviceState, MetricFormat | undefined> = {
  charging: "percentage",
  discharging: "percentage",
  on: "kW",
  idle: undefined,
  off: undefined,
  heat: "temperature",
  cool: "temperature",
  auto: "temperature",
  eco: "temperature",
  unknown: undefined,
  connected: undefined,
  disconnected: undefined,
} as const;

/**
 * Device states that represent active/operational conditions
 * Used for pulsing indicators, priority sorting, etc.
 */
export const activeDeviceStates: readonly DeviceState[] = [
  "charging",
  "discharging",
  "heat",
  "cool",
  "on",
  "connected",
] as const;

/**
 * Human-readable labels for device states
 */
export const deviceStateLabels: Record<DeviceState, string> = {
  unknown: "Unknown",
  on: "On",
  off: "Off",
  idle: "Idle",
  charging: "Charging",
  discharging: "Discharging",
  heat: "Heating",
  eco: "Eco Mode",
  cool: "Cooling",
  auto: "Auto",
  connected: "Connected",
  disconnected: "Disconnected",
} as const;

/**
 * Check if a device state represents an active/operational state
 */
export function isActiveState(state: DeviceState): boolean {
  return activeDeviceStates.includes(state);
}

/**
 * Get human-readable label for a device state
 */
export function getDeviceStateLabel(state: DeviceState): string {
  return deviceStateLabels[state];
}
